import { useWSModalCustom } from "@wingspanhq/fe-component-library";
import { CreateContractorModal } from "./index";

export const useCreateContractorModal = () =>
  useWSModalCustom(CreateContractorModal);
